import { Icon } from '../icons';

// "Came back 3× since Mar 2026" (P5-02): how often an idea's theme returned —
// duplicates, merges and later captures close to it. Pro only; the API sends
// nothing on free, so this renders nothing there.

/** Below this an echo is just a duplicate, not a pattern. */
export const RECURRENCE_BADGE_MIN = 2;

function sinceLabel(since: string): string {
  const d = new Date(since.includes('T') ? since : since.replace(' ', 'T') + 'Z');
  const sameYear = d.getFullYear() === new Date().getFullYear();
  return d.toLocaleDateString('en-US', sameYear ? { month: 'short', day: 'numeric' } : { month: 'short', year: 'numeric' });
}

export function recurrenceText(count: number, since?: string | null): string {
  return `Came back ${count}×${since ? ` since ${sinceLabel(since)}` : ''}`;
}

export function RecurrenceBadge({ count, since }: { count: number | undefined; since?: string | null }) {
  if (!count || count < RECURRENCE_BADGE_MIN) return null;
  return (
    <span className="recur-badge" title="Duplicates, merges and later captures close to this idea">
      <Icon name="retry" size={12} />
      {recurrenceText(count, since)}
    </span>
  );
}
